module.exports = __webpack_public_path__ + "img/paypal.2482cb72.svg";